import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import InputMask from 'react-input-mask';
import { Modal } from 'react-bootstrap';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class SigtripVoeOmniLogs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      date: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.findLogs = this.findLogs.bind(this);
    this.file = this.file.bind(this);
    this.pdfButton = this.pdfButton.bind(this);
    this.exportPdf = this.exportPdf.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      var now = new Date();
      var month = (now.getMonth()) + 1;
      var year = now.getFullYear();
      var day = now.getDate();
      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }
      var reference = day + '/' + month + '/' + year;
      this.setState({loaded: 2, date: reference}, this.loadData(reference));
    }
  }

  loadData(reference) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    var datasave = {
        date: reference,
    };
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigtrip') + '/logs/voeomni', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  findLogs(event) {
    event.preventDefault();
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    var datasave = {
      date: this.state.date,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigtrip') + '/logs/voeomni', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'closed'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  pdfButton(cell) {
    return <button onClick={() => {this.exportPdf(cell)}} className="btn btn-info"><i className="fa fa-fw fa-file-pdf-o"></i> Download</button>;
  }

  exportPdf(file) {
    window.open(config.get('cdn_sigtrip') + '/files/voeomni/' + file);
  }

  file(cell) {
    var json = cell;
    try {
      json = JSON.parse(cell);
      json = JSON.stringify(json, null, '\t');
    } catch (e) {
      console.error(e);
    }

    return <button className="btn btn-primary" onClick={() => { this.openModal(json); }}>Ver arquivo</button>;
  }

  openModal(json) {
    this.setState({modal: true, data_modal: json});
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">Logs - VoeOmni</h3>
      <hr/>
      <form onSubmit={this.findLogs}>
        <div className="row">
          <div className="col-md-8">
            <InputMask value={this.state.date}  maskChar={null} name="name" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="" />
          </div>
          <div className="col-md-4">
            <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> Buscar</button>
          </div>
        </div>
      </form>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há logs cadastrados', defaultSortName: 'arquivo', defaultSortOrder: 'desc', sizePerPage: 100, sizePerPageList: [{text: '10', value: 10}, {text: '25', value: 25}, {text: '50', value: 50}, {text: '100', value: 100}]}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar' expandComponent={ this.expandComponent } expandableRow={ this.expandableRow }>
        <TableHeaderColumn dataField="arquivo" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='100'>Arquivo</TableHeaderColumn>
        <TableHeaderColumn dataField="dados" dataAlign="center" dataFormat={this.file} width='50'>Ações</TableHeaderColumn>
        <TableHeaderColumn dataField="arquivo" dataAlign="center" dataFormat={this.pdfButton} width='50'>Baixar</TableHeaderColumn>
      </BootstrapTable>
    </div>
  </div>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Request detalhado</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => { self.setState({modal: false}) }}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <pre>{this.state.data_modal}</pre>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => { self.setState({modal: false}) }}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default SigtripVoeOmniLogs;



// WEBPACK FOOTER //
// ./src/Components/Sigtrip/SigtripVoeOmniLogs.js